/* Psolys · shared behaviour (Kairo's): bag, nav, menu, reveals, toast, money.
   Two modes: on localhost the bag lives in localStorage (demo); inside the Shopify theme (html[data-shopify])
   the same buttons use Shopify's AJAX cart and checkout. */
(() => {
  const doc = document.documentElement;
  doc.classList.remove('no-js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SHOPIFY = doc.dataset.shopify === '1';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const PRODUCTS = { brosse: { product: 'brosse', name: 'La Brosse Rituel N°1', price: 29.99, options: 'Silicone crème, marquage vert sauge', img: doc.dataset.thumb || 'assets/img/brush-thumb.webp' } };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- money and dates ---------- */
  const money = (n) => {
    const whole = Math.abs(n % 1) < 0.005;
    return n.toLocaleString('fr-FR', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }) + '\u00a0€';
  };
  const DAY = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const MONTH = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const fmtDay = d => `${DAY[d.getDay()]} ${d.getDate()} ${MONTH[d.getMonth()]}`;
  const fmtDate = d => `${d.getDate()} ${MONTH[d.getMonth()]} ${d.getFullYear()}`;
  /* Order by 18:00 and it arrives in 3 working days, after 18:00 in 4. Weekends do not count. */
  const deliveryDate = (now = new Date()) => {
    let n = now.getHours() < 18 ? 3 : 4;
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  };
  const addMonths = (date, m) => { const d = new Date(date); const day = d.getDate(); d.setMonth(d.getMonth() + m); if (d.getDate() < day) d.setDate(0); return d; };
  const deliveryLine = () => '';

  /* ---------- bag store (localStorage, never leaves the browser) ---------- */
  const KEY = 'psolys.bag.v1';
  /* items saved before the price was known get it filled in from the catalogue */
  const read = () => { let items; try { items = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { items = []; } return items.map(i => (typeof i.price !== 'number' && PRODUCTS[i.product]) ? { ...i, price: PRODUCTS[i.product].price, name: PRODUCTS[i.product].name } : i); };
  const write = (items) => { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} updateCount(true); document.dispatchEvent(new CustomEvent('bag:change')); };
  const lineKey = i => [i.product, i.finish || '', i.size || '', i.band || ''].join('|');
  const bag = {
    items: read,
    count: () => read().reduce((s, i) => s + i.qty, 0),
    add(item) {
      const items = read(); const k = lineKey(item); const found = items.find(i => lineKey(i) === k);
      if (found) found.qty = Math.min(found.qty + (item.qty || 1), 10); else items.push({ qty: 1, care: false, ...item });
      write(items); return item;
    },
    setQty(key, qty) { let items = read(); const it = items.find(i => lineKey(i) === key); if (!it) return; it.qty = Math.max(0, Math.min(10, qty)); items = items.filter(i => i.qty > 0); write(items); },
    remove(key) { write(read().filter(i => lineKey(i) !== key)); },
    setCare(key, on) { const items = read(); const it = items.find(i => lineKey(i) === key); if (it) { it.care = on; write(items); } },
    clear() { write([]); },
    key: lineKey,
    totals() {
      const items = read();
      /* the price is not set yet: totals stay null until Lou gives it */
      const known = items.every(i => typeof i.price === 'number');
      const total = known ? items.reduce((s, i) => s + i.price * i.qty, 0) : null;
      return { items, total, known, count: items.reduce((s, i) => s + i.qty, 0) };
    }
  };
  function updateCount(bump, known) {
    const n = typeof known === 'number' ? known : SHOPIFY ? +(($('[data-bag-count]') || {}).textContent || 0) : bag.count();
    $$('[data-bag-count]').forEach(el => { el.textContent = n; el.classList.toggle('is-on', n > 0); if (bump && n > 0 && !reduce) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); } });
    $$('[data-bag-label]').forEach(el => el.textContent = n ? `Panier, ${n} article${n > 1 ? 's' : ''}` : 'Panier vide');
  }

  /* ---------- toast ---------- */
  let toastTimer;
  const toast = (title, text, img) => {
    const t = $('[data-toast]'); if (!t) return;
    $('[data-toast-text]', t).innerHTML = `<b>${title}</b>${text}`;
    if (img) $('img', t).src = img;
    t.classList.add('is-on'); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 4200);
  };

  /* ---------- nav: scrolled state, hide on scroll, menu ---------- */
  const nav = $('#nav');
  let lastY = scrollY, ticking = false, locked = 0;
  const onScroll = () => {
    ticking = false; const y = scrollY;
    if (nav) {
      nav.classList.toggle('is-scrolled', y > 24);
      const open = document.body.classList.contains('nav-open');
      if (!open && !nav.hasAttribute('data-nohide')) {
        if (y > 240 && y - lastY > 6) nav.classList.add('is-hidden');
        else if (lastY - y > 6 || y < 240) nav.classList.remove('is-hidden');
      }
    }
    lastY = y;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();
  const menuBtn = $('[data-menu-toggle]'), menu = $('#menu');
  const setMenu = (open) => {
    const b = document.body; if (b.classList.contains('nav-open') === open) return;
    if (open) { locked = scrollY; Object.assign(b.style, { position: 'fixed', top: -locked + 'px', left: '0', right: '0', width: '100%' }); }
    b.classList.toggle('nav-open', open);
    if (!open) { Object.assign(b.style, { position: '', top: '', left: '', right: '', width: '' }); scrollTo({ top: locked, behavior: 'instant' }); }
    menuBtn && menuBtn.setAttribute('aria-expanded', String(open));
    menu && menu.setAttribute('aria-hidden', String(!open));
    if (menuBtn) menuBtn.querySelector('use').setAttribute('href', open ? '#i-close' : '#i-menu');
    if (open && nav) nav.classList.remove('is-hidden');
  };
  menuBtn && menuBtn.addEventListener('click', () => setMenu(!document.body.classList.contains('nav-open')));
  menu && menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
  addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });
  const page = document.body.dataset.page;
  $$('[data-nav]').forEach(a => { if (a.dataset.nav === page) a.setAttribute('aria-current', 'page'); });

  /* ---------- split words, reveals ---------- */
  $$('[data-split]').forEach(el => {
    if (el.dataset.splitDone) return; el.dataset.splitDone = '1';
    let i = 0;
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span'); w.className = 'wm'; w.setAttribute('aria-hidden', 'true');
            const s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++); w.appendChild(s); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    };
    const label = el.textContent.replace(/\s+/g, ' ').trim();
    walk(el); el.setAttribute('aria-label', label);
  });
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); e.target.dispatchEvent(new CustomEvent('reveal')); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }) : null;
  const observe = (root = document) => $$('.rv, [data-reveal], [data-split]', root).forEach(el => { if (!io || reduce) { el.classList.add('in'); el.dispatchEvent(new CustomEvent('reveal')); } else io.observe(el); });
  observe();

  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());
  $$('[data-delivery]').forEach(el => el.textContent = deliveryLine());
  $$('[data-delivery-day]').forEach(el => el.textContent = fmtDay(deliveryDate()));
  updateCount(false);
  addEventListener('storage', e => { if (e.key === KEY) { updateCount(false); document.dispatchEvent(new CustomEvent('bag:change')); } });

  /* ---------- quick add buttons ---------- */
  const shopifyAdd = async (b) => {
    b.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.variant, quantity: 1 }] }) });
      const added = await r.json();
      if (!r.ok) { toast('Oups', added.description || 'Impossible d’ajouter ce produit pour le moment.', PRODUCTS.brosse.img); return; }
      const cart = await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      updateCount(true, cart.item_count);
      if (window.umami) umami.track('Ajout au panier');
      const it = added.items ? added.items[0] : added;
      toast('Ajoutée au panier', `${it.product_title} · ${money(it.final_price / 100)}`, PRODUCTS.brosse.img);
    } catch (err) { toast('Oups', 'Connexion impossible. Réessaie dans un instant.', PRODUCTS.brosse.img); }
    finally { b.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', e => { if (e.target.closest('button[name=checkout]') && window.umami) umami.track('Paiement commencé'); });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add]'); if (!b) return;
    e.preventDefault();
    if (SHOPIFY && b.dataset.variant) { shopifyAdd(b); return; }
    const item = PRODUCTS[b.dataset.add]; if (!item) return;
    bag.add({ ...item });
    toast('Ajoutée au panier', `${item.name} · ${money(item.price)}`, item.img);
  });

  /* ---------- diagrams of the dark section ---------- */
  const HAIR = '<g class="hair"><path d="M70 132c-4-40 6-80 0-118"/><path d="M160 132c4-44-6-82 2-118"/><path d="M250 132c-6-38 4-78-2-118"/></g>';
  const SKIN = '<rect class="skin2" x="16" y="132" width="288" height="18" rx="9"/><rect class="skin" x="16" y="146" width="288" height="34" rx="12"/>';
  const DG = {
    pile: `<svg viewBox="0 0 320 200" class="dg dg--pile">${SKIN}${HAIR}<g class="flakes"><rect x="40" y="118" width="70" height="12" rx="6"/><rect x="118" y="118" width="84" height="12" rx="6"/><rect x="210" y="118" width="72" height="12" rx="6"/><rect x="56" y="104" width="64" height="12" rx="6"/><rect x="130" y="104" width="60" height="12" rx="6"/><rect x="198" y="104" width="70" height="12" rx="6"/><rect x="84" y="90" width="58" height="12" rx="6"/><rect x="170" y="90" width="66" height="12" rx="6"/></g></svg>`,
    block: `<svg viewBox="0 0 320 200" class="dg dg--block">${SKIN}${HAIR}<g class="flakes"><rect x="30" y="112" width="260" height="18" rx="9"/></g><g class="drops"><path d="M108 40c6 8 10 13 10 18a10 10 0 0 1-20 0c0-5 4-10 10-18Z"/><path d="M200 26c6 8 10 13 10 18a10 10 0 0 1-20 0c0-5 4-10 10-18Z"/><path d="M232 52c5 7 8 11 8 15a8 8 0 0 1-16 0c0-4 3-8 8-15Z"/></g></svg>`,
    nail: `<svg viewBox="0 0 320 200" class="dg dg--nail">${SKIN}<g class="flakes"><rect x="34" y="118" width="64" height="12" rx="6"/><rect x="226" y="118" width="64" height="12" rx="6"/></g><g class="nicks"><path d="M146 138l12 9M166 136l12 10M186 138l12 9"/></g><g class="finger-move"><g transform="translate(222 58) rotate(40)"><rect class="finger" x="-24" y="-170" width="48" height="232" rx="24"/><rect class="nail" x="-17" y="22" width="34" height="34" rx="14"/></g></g></svg>`,
    bend: `<svg viewBox="0 0 320 200" class="dg dg--bend"><rect class="skin2" x="16" y="150" width="288" height="12" rx="6"/><rect class="skin" x="16" y="158" width="288" height="26" rx="12"/><g class="hair"><path d="M40 150c-3-30 4-60 0-90"/><path d="M160 150c3-32-4-62 1-92"/><path d="M282 150c-3-30 4-60 0-90"/></g><g class="press"><rect x="44" y="24" width="96" height="12" rx="6" fill="rgba(255,250,241,.35)"/><rect x="180" y="24" width="96" height="12" rx="6" fill="rgba(255,250,241,.35)"/></g><rect class="pic pic--soft soft" x="84" y="52" width="16" height="96" rx="8"/><rect class="pic" x="222" y="52" width="10" height="96" rx="5"/><circle class="ko" cx="118" cy="62" r="6"/><circle class="ok" cx="248" cy="62" r="6"/><text class="lbl" x="92" y="196" text-anchor="middle">classique</text><text class="lbl" x="227" y="196" text-anchor="middle">rituel n°1</text></svg>`
  };
  $$('[data-dg]').forEach(el => { el.innerHTML = DG[el.dataset.dg] || ''; el.setAttribute('aria-hidden', 'true'); });
  $$('.sci-card').forEach(card => card.addEventListener('reveal', () => { const dg = $('.dg', card); if (dg) dg.parentElement.classList.add('in'); }, { once: true }));

  window.psolys = { $, $$, money, bag, toast, fmtDay, fmtDate, reduce, observe, setMenu, PRODUCTS, SHOPIFY, ROOT, updateCount };
})();
